import { GENERIC_FORMATS } from "./ImportModal";

/** Full-screen target shown while a file is dragged anywhere over the page. */
export function DropOverlay() {
  return (
    <div className="kl-dropzone">
      <div className="kl-dropzone-inner">
        <div className="kl-dropzone-big">Drop to load it through the lens</div>
        <div className="kl-dropzone-sub">{GENERIC_FORMATS}</div>
      </div>
    </div>
  );
}
